import { on, fire } from "delegated-events";
import autoComplete from "@tarekraafat/autocomplete.js";
import "@styles/components/autocomplete.css";
import easydropdown from "easydropdown-a11y";
import "@styles/components/dropdown.css";

const setupSearch = (component) => {
  const field = component.querySelector('[name="search"]');
  const form = field.closest("form");
  const data = JSON.parse(component.querySelector(".program-search-data").textContent);

  const searchField = new autoComplete({
    selector: () => field,
    data: {
      src: data,
      keys: ["title", "keywords"],
      filter: (list) => {
        const uniqueResults = new Map();

        list.forEach((item) => {
          if (!uniqueResults.has(item.value.title)) {
            uniqueResults.set(item.value.title, item);
          }
        });

        return [...uniqueResults.values()];
      },
    },
    resultsList: {
      maxResults: 99,
    },
    resultItem: {
      element: (item, data) => {
        item.innerHTML = `
          <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
            ${data.value.title} <span style="font-size: 0.75em">(${data.value.type})</span>
          </span>
        `;
      },
    },
    submit: true,
  });

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    const query = form.querySelector('[type="search"]').value.trim();

    if (!query) {
      return false;
    }

    if (component.classList.contains("is-programs-page")) {
      fire(document.documentElement, "programsearch:query", {
        value: query,
      });

      searchField.close();
    } else {
      form.submit();
    }
  });

  searchField.input.addEventListener("selection", (e) => {
    const feedback = e.detail;
    searchField.input.blur();

    searchField.input.value = null;

    const selectedProgram = feedback.selection.value.slug;

    if (component.classList.contains("is-programs-page")) {
      fire(document.documentElement, "programsearch:program", {
        value: selectedProgram,
      });
    } else {
      const url = new URL(form.action);
      const params = new URLSearchParams({ program: selectedProgram });
      url.search = params.toString();

      window.location.href = url;
    }
  });
};

const setupDropdown = (select) => {
  const opts = {
    behavior: {
      openOnFocus: true,
      maxVisibleItems: 10,
      liveUpdates: true,
      useNativeUiOnMobile: false,
    },
  };

  easydropdown(select, opts);
};

document.querySelectorAll(".component-program-search").forEach((el) => {
  setupSearch(el);
  setupDropdown(el.querySelector("select"));
});

on("change", ".program-area-form select", (e) => {
  const value = e.target.value;
  const form = e.target.closest("form");
  const component = e.target.closest(".component-program-search");

  if (component.classList.contains("is-programs-page")) {
    fire(document.documentElement, "programsearch:area", {
      value,
    });
  } else {
    form.submit();
  }
});

on("programsearch:clearall", "html", () => {
  document.querySelectorAll(".component-program-search").forEach((el) => {
    el.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null));
    el.querySelectorAll("select").forEach((x) => (x.value = null));
  });
});

on("programsearch:clearquery", "html", () => {
  document.querySelectorAll(".component-program-search").forEach((el) => {
    el.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null));
  });
});

on("programsearch:cleararea", "html", () => {
  document.querySelectorAll(".component-program-search").forEach((el) => {
    el.querySelectorAll("select").forEach((x) => (x.value = null));
  });
});
